import React from "react";
import Export from "../components/Export";
import TopNav from "../components/TopNav";
import Sidebar from "../components/SideNav";
import Footer from "../components/Footer";

const ExportPage = () => {
  return (
    <div style={{}}>
      <div className="sticky-top topHeader z-3">
        <TopNav />
      </div>
      <div className="d-flex flex-grow-1">
        <aside
          style={{
            position: "sticky",
            height: "calc(100vh - 120px)",
            top: "66px",
          }}
        >
          <Sidebar />
        </aside>
        <main
          className="flex-grow-1 p-4 overflow-auto w-25 bg-theme-light"
        >
          <div className="mb-4">
            <h2>
              Export Data to Excel
            </h2>
            <p className="text-muted">
              Select filters and export district-level data to Excel format
            </p>
          </div>
          <Export />
        </main>
      </div>
      <div className="sticky-bottom z-3">
        <Footer />
      </div>
    </div>
  );
};

export default ExportPage;